<template>
  <div class="page-wrap campus-manage">
    <transition name="default" mode="out-in">
      <router-view
        :update-component="updateComponent"
        :key="$route.path"
      ></router-view>
    </transition>
  </div>
</template>

<script>
import PageHeader from '../../components/PageHeader.vue'
import { mapGetters } from 'vuex'
import aliOSS from 'ali-oss'

export default {
  components: {
    PageHeader
  },

  data() {
    return {
      updateComponent: new Date().toString(),

      // aliOSS实例
      aliOSSClient: null,

      modalVisible: false,
      modalLoading: false,
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 19 }
      },

      // 上传的文件
      uploadFile: null,
      uploadLoading: false
    }
  },

  computed: {
    ...mapGetters(['categoryRouterList', 'handleRightsList'])
  },

  methods: {
    initAliOSS() {
      this.aliOSSClient = new aliOSS({
        region: this.$config.region,
        accessKeyId: this.$config.accessKeyId,
        accessKeySecret: this.$config.accessKeySecret,
        bucket: this.$config.bucket
      })
    },

    handleAdd() {
      if (!this.aliOSSClient) {
        this.initAliOSS()
      }
      this.modalVisible = true
    },

    // 上传之前
    beforeUpload(file) {
      this.uploadFile = file
    },

    // 自定义上传,参数中的方法可以控制上传的进度
    customRequest({ onSuccess }) {
      this.uploadLoading = true

      const primaevalName = this.uploadFile.name
      const name = primaevalName.slice(0, primaevalName.lastIndexOf('.'))
      const suffix = primaevalName.slice(
        primaevalName.lastIndexOf('.'),
        primaevalName.length
      )
      const date = new Date()
      const fileName = `${name}_${date.getTime()}${suffix}`

      this.aliOSSClient
        .multipartUpload(fileName, this.uploadFile, {})
        .then(results => {
          // 返回上传的信息
          let fileUrl = ''
          if (results.url) {
            fileUrl = results.url
          } else if (results.res.requestUrls) {
            const result = results.res.requestUrls
            if (result[0].indexOf('?') !== -1) {
              fileUrl = result[0].slice(0, result[0].indexOf('?'))
            } else {
              fileUrl = result[0]
            }
          }
          this.uploadLoading = false
          onSuccess(fileUrl)
        })
        .catch(() => {
          this.$message({
            message: this.$t('public.uploadFailed'),
            type: 'warning',
            showClose: true,
            duration: 1000
          })
        })
    },

    // 提交
    ok() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.handleSave(values)
        }
      })
    },

    handleSave(values) {
      this.modalLoading = true
      this.$http(this.$api.SAVECAMPUS, {
        name: values.campusName,
        icon: values.logo.fileList[values.logo.fileList.length - 1].response,
        address: values.address
      })
        .then(() => {
          this.$message.success(this.$t('public.saveSuccess'))
          this.updateComponent = new Date().toString()
          this.modalVisible = false
        })
        .catch(() => {
          this.modalLoading = false
        })
    },

    afterClose() {
      this.form.resetFields()
      this.uploadFile = null
      this.modalLoading = false
    },

    handleTap(component) {
      this.$router.push({
        name: component.name
      })
    }
  }
}
</script>
